export default __webpack_public_path__ + "static/media/bazzle_vm_2.e47f32cf.png";